<template>
  <section class="logo-container">
    <!-- <Transition name="small-logo" v-if="false"> -->
      <div class="small-logo" v-if="collapsed">
        <!-- <img
          :width="37"
          :src="
            settings_store.settings.resolved_theme === 'Dark'
              ? LogoSmall
              : LogoSmallDark
          "
        /> -->
        SBS
      </div>
      <div class="big-logo" v-else>
        <!-- <img
          :width="size"
          :src="
            settings_store.settings.resolved_theme === 'Dark' ? Logo : LogoDark
          "
        /> -->
        SmartBot
        <div v-if="show_admin" class="admin-title">Business</div>
      </div>
    <!-- </Transition> -->
  </section>
</template>
<script setup lang="ts">
import Logo from '@/assets/tenants/emiratai/images/logo@2x.png'
import LogoDark from '@/assets/tenants/emiratai/images/logo@2x-dark.png'
import LogoSmall from '@/assets/tenants/emiratai/images/ai@2x.png'
import LogoSmallDark from '@/assets/tenants/emiratai/images/ai@2x-dark.png'
import { useSettingsStore } from '@/stores/settings'

withDefaults(
  defineProps<{
    collapsed?: boolean
    show_admin?: boolean
  }>(),
  {
    show_admin: true,
  },
)
const size = 181 / 2

const settings_store = useSettingsStore()
</script>
<style scoped>
.big-logo-enter-active,
.big-logo-leave-active {
  transition: opacity 0.25s ease-in;
}

.big-logo-enter-from,
.big-logo-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}
.small-logo-enter-active,
.small-logo-leave-active {
  transition: all 0.25s ease-in;
}

.small-logo-enter-from,
.small-logo-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}

.logo-container {
  display: flex;
  position: relative;
  align-items: center;
  padding-left: 23px;
  height: 74px;
}
.logo-icon {
  font-size: 32px;
  color: var(--sidebar-text);
}
.slogo {
  padding-left: 10px;
}
.small-logo {
  position: absolute;
  /* top: -4px; */
}
.big-logo {
  display: flex;
  align-items: center;
  position: absolute;
  /* top: -6px; */
  padding: 5px;
  font-size: 20px;
  font-weight: 700;
  width: fit-content;
  flex-wrap: nowrap;
}
.admin-title {
  position: relative;
  font-weight: 400;
  margin-left: 10px;
  font-size: 13px;
  border: 1px solid var(--color-text);
  padding: 0px 5px 1px 5px;
  border-radius: 5px;
  line-height: 16px;
  text-transform: uppercase;
}

.bayentek-logo {
  color: var(--sidebar-text);
  font-size: 20px;
  margin: 0 0 0 12px;
  font-weight: 600;
  vertical-align: middle;
}
.version {
  font-size: 11px;
  display: block;
  position: relative;
  border: 1px solid gray;
  border-radius: 5px;
  height: 16px;
  width: fit-content;
  line-height: 13px;
  padding: 1px 3px 0 3px;
}
</style>
